<template>
    <svg
        width="802"
        height="258"
        viewBox="0 0 802 258"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="sign-up-component">
            <text
                id="Explore further with us!"
                fill="white"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Alegreya"
                font-size="48"
                letter-spacing="0em"
            >
                <tspan x="173" y="48.768">Explore further with us!</tspan>
            </text>
            <g id="learn-more-button" @click="clickHandler">
                <rect
                    id="Rectangle"
                    x="209"
                    y="118"
                    width="385"
                    height="136"
                    fill="#EAE4E4"
                    stroke="white"
                    stroke-width="8"
                ></rect>
                <text
                    fill="#3353FF"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Heebo"
                    font-size="48"
                    font-weight="900"
                    letter-spacing="0em"
                >
                    <tspan x="274" y="201.297">LET&#x2019;S TALK</tspan>
                </text>
            </g>
        </g>
    </svg>
</template>




<script>
export default {
    methods: {
        clickHandler() {
            this.$emit('close')
            this.$store.commit('openSignUp', 'Data Strategy')
        }
    }
}
</script>

<style lang="stylus" scoped>
#learn-more-button
    cursor: pointer

#learn-more-button:hover
    & > rect
        fill: white
</style>

